import { z } from 'zod';
/**
 * Delete Partner News Response
 * DELETE /api/v2/admin/partner-news/:id
 */ export const DeletePartnerNewsResponseSchema = z.object({
    success: z.literal(true)
});

//# sourceMappingURL=delete-partner-news.schema.js.map